import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalFunctions } from '@global/GlobalFunctions';
import { siteSubscriptions } from '@services/siteSubscriptions';
import { environment } from '@environments/environment';
import { distinctUntilChanged, Observable } from 'rxjs';


export class UploadFile {
	/**
	 * UploadFile
	 * @param container container
	 * @param file file
	 * @param filename filename
	 * @param folderLocation Folder Location
	 */
	constructor(
		/** container */
		public container: string,
		/** File Blob */
		public fileBlob: File,
		/** Filename */
		public filename: string,
		/** folderLocation */
		public folderLocation: string
	) { }
}

@Injectable({
	providedIn: 'root'
})
export class FilesService {

	/** apiAssets */
	private apiFiles = "api/files";
	private storageContainer = environment.production ? "prismpdm" : "prismpdm-dev";

	/**
   * Default Constructor
   * @param http Imports the 'HttpClient' Object for internet requests
   * @param globalFunctions Global Functions
   * @param siteSubscriptions site Subscriptions
   */
	constructor(
		private http: HttpClient,
		public globalFunctions: GlobalFunctions,
		public siteSubscriptions: siteSubscriptions
	) { }


	/**
	   * Upload a File to Azure storage
	   * @param container Blob Storage Conatiner path
	   * @param file      File as a blob
	   * @param filename  Filename to save file as
	   * @param folderLocation Location folder to store file
	   * @returns
	   */
	uploadFile$(container: string, accountGUID: string, file: File, filename: string, folderLocation: string): Observable<any> {

		// Set a temp file to load the blob dat into
		let url = `${environment.apiUrl}/${this.apiFiles}`

		// Create form data
		const formData = new FormData();

		// Set the Storage Blob Container (folder in Blob Containers)
		formData.append("container", container)
		// Set the Storage Blob Container (folder in Blob Containers)
		formData.append("accountGUID", accountGUID)
		// Store form name as "file" with file data
		formData.append("file", file, filename);//file.name);
		// Send filename for completeness
		formData.append("filename", filename);
		// State folder location for blob storage
		formData.append("folderlocation", folderLocation)

		// Make http post request over api
		// with formData as req
		// return this.http.put(url, formData)

		return this.globalFunctions.putForm(this.http, url, "PUT", formData);

	}

	/**
	 * Upload Image to azure storage
	 * @param accountGUID Account GUID
	 * @param fileName Filename
	 * @param file File 
	 * @param location Location 
	 * @param [silent=false] 
	 * @returns Promise<void>
	 */
	saveImage(accountGUID: string, fileName: string, file: File, location: string, silent: boolean = false): Promise<void> {

		return new Promise((resolve, reject) => {
			try {
				this.uploadFile$(this.storageContainer, accountGUID, file, fileName, location
				).pipe(
					distinctUntilChanged()
				).subscribe({
					next: (response: any) => {
						if (typeof response === 'object') {
							// file = undefined;
							if (!silent){
								this.globalFunctions.DisplaySnackBar({ message: "File Uploaded", action: "", duration: 2000 });
							}
							resolve(); // ✅ resolve the Promise when done
						}
					},
					error: (err) => {
						this.globalFunctions.HandleError(err, "");
						reject(err); // reject the Promise on error
					}
				});

			} catch (error) {
				this.globalFunctions.HandleError(error, "");
				reject(error);
			}
		});
	}

	/**
	 * postAssetInformationFile
	 * @param AccountGUID AccountGUID 
	 * @param orgUID orgUID 
	 * @param assetInformationGUID assetInformationGUID  
	 * @param file file 
	 * @returns 
	 */
	postAssetInformationFile$(AccountGUID: string, orgUID: string, assetInformationGUID: string, file: FormData): Observable<any> {
		const data = file;

		let url = this.apiFiles;
		url = url.replace("{0}", AccountGUID);
		url = url.replace("{1}", orgUID);

		url = `${environment.apiUrl}/${url}/assetInformationFiles/${assetInformationGUID}`;

		return this.globalFunctions.fetchAPI(this.http, url, "POST", data, { noContentType: true });
	}

	/**
	 * getAssetInformationFile
	 * @param AccountGUID AccountGUID 
	 * @param orgUID orgUID 
	 * @param assetInformationGUID assetInformationGUID  
	 * @returns 
	 */
	getAssetInformationFile$(AccountGUID: string, orgUID: string, assetInformationGUID: string): Observable<any> {
		const data = {};

		let url = this.apiFiles;
		url = url.replace("{0}", AccountGUID);
		url = url.replace("{1}", orgUID);

		url = `${environment.apiUrl}/${url}/assetInformationFiles/${assetInformationGUID}`;

		return this.globalFunctions.fetchAPI(this.http, url, "GET", data, { responseType: 'blob' });
	}

	/**
	 * deleteAssetInformationFile
	 * @param AccountGUID AccountGUID 
	 * @param orgUID orgUID 
	 * @param assetInformationGUID assetInformationGUID  
	 * @returns 
	 */
	deleteAssetInformationFile$(AccountGUID: string, orgUID: string, assetInformationGUID: string): Observable<any> {
		const data = {};

		let url = this.apiFiles;
		url = url.replace("{0}", AccountGUID);
		url = url.replace("{1}", orgUID);

		url = `${environment.apiUrl}/${url}/assetInformationFiles/${assetInformationGUID}`;

		return this.globalFunctions.fetchAPI(this.http, url, "DELETE", data);
	}
}
